import { PaymentFor } from '../enums';
import { Guid } from '@fitscovery/common/types';

export class CreatePaymentIntent {

  static readonly type = '[Payment] CreatePaymentIntent';
  constructor(public data: { itemId: string | Guid, paymentFor: PaymentFor}) { }
}

export class GetPaymentIntentFromProvider {
  static readonly type = '[Payment] GetPaymentIntentFromProvider';

  constructor(public data: { paymentProviderIntentId: string, clientKey?: string}) { }
}
